// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"172":"invoices","443":"about","535":"login","764":"payment","851":"expense"}[chunkId] || chunkId) + "." + {"172":"15642a47","443":"51bf8723","535":"79bad1d4","764":"4aa7b0ef","842":"af889797","851":"5e2e1464"}[chunkId] + ".js";
};